import { applyMiddleware, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import "./i18n";

import React from "react";

import { BrowserRouter } from "react-router-dom";
import App from "App";


import { Provider as ReduxProvider } from "react-redux";
import thunk from "redux-thunk";
import reducer from "./reducers";
import ReactDOM from 'react-dom/client';
import MuiSnackbar from "./components/MDSnackbar";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const container = document.getElementById("app");
const root = ReactDOM.createRoot(container);

const reduxStore = createStore(
  reducer, {},

  composeWithDevTools(
    applyMiddleware(thunk)
  )
);

// const queryClient = new QueryClient({
//     defaultOptions: {
//         queries: {
//             // retry: 1,
//             retry: 0,
//             refetchOnWindowFocus: false,
//             // staleTime: 30 * 1000, // 30 秒内不算 stale
//             staleTime: 0,
//             gcTime: 0,  // v5
//         },
//     },
// });

root.render(
  <BrowserRouter>
    <ReduxProvider store={reduxStore}>
      {/*<MaterialUIControllerProvider>*/}
      {/*  <DevSupport ComponentPreviews={ComponentPreviews}*/}
      {/*              useInitialHook={useInitial}*/}
      {/*  >*/}
      {/*  <QueryClientProvider client={queryClient}>*/}
            <App />
            <MuiSnackbar/>
        {/*</QueryClientProvider>*/}
        {/*</DevSupport>*/}
      {/*</MaterialUIControllerProvider>*/}
    </ReduxProvider>
  </BrowserRouter>
);
